import produce from "immer";

import {
  ACTIVE_CAMPAIGN_SUCCESS,
  CREATE_CAMPAIGN_FAILURE,
  CREATE_CAMPAIGN_REQUEST,
  CREATE_CAMPAIGN_SUCCESS,
  EDIT_CAMPAIGN_FAILURE,
  EDIT_CAMPAIGN_REQUEST,
  EDIT_CAMPAIGN_SUCCESS,
  GET_CAMPAIGN_FAILURE,
  GET_CAMPAIGN_REQUEST,
  GET_CAMPAIGN_SUCCESS,
  GET_CATEGORY_FAILURE,
  GET_CATEGORY_REQUEST,
  GET_CATEGORY_SUCCESS,
  GET_DETAIL_CAMPAIGN_FAILURE,
  GET_DETAIL_CAMPAIGN_REQUEST,
  GET_DETAIL_CAMPAIGN_SUCCESS,
  UPDATE_CAMPAIGN_FAILURE,
  UPDATE_CAMPAIGN_REQUEST,
  UPDATE_CAMPAIGN_SUCCESS
} from "src/actions/campaignAction";

const initialState = {
  listCampaign: [],
  campaign: {},
  total: 0,
  loading: false,
  listCategory: []
};
const campaignReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CAMPAIGN_REQUEST: {
      return produce(state, (draft) => {
        draft.listCampaign = [];
        draft.loading = true;
      });
    }
    case GET_CAMPAIGN_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.listCampaign = response?.data;
        draft.total = response?.total_items;
        draft.loading = false;
      });
    }
    case GET_CAMPAIGN_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }
    case CREATE_CAMPAIGN_REQUEST: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }
    case CREATE_CAMPAIGN_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.listCampaign = draft.listCampaign.concat(response);
        draft.loading = true;
      });
    }
    case CREATE_CAMPAIGN_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }
    case EDIT_CAMPAIGN_REQUEST: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }
    case EDIT_CAMPAIGN_SUCCESS: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }
    case EDIT_CAMPAIGN_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }
    case ACTIVE_CAMPAIGN_SUCCESS: {
      const {id, data} = action.payload;
      return produce(state, (draft) => {
        draft.listCampaign = state.listCampaign.map((item) => {
          if (item.id === id) {
            return {
              ...item,
              is_active: data
            };
          }
          return item;
        });
      });
    }
    case GET_CATEGORY_REQUEST: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }
    case GET_CATEGORY_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.listCategory = response?.data;
        draft.loading = false;
      });
    }
    case GET_CATEGORY_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    case GET_DETAIL_CAMPAIGN_REQUEST: {
      return produce(state, (draft) => {
        draft.campaign = {};
        draft.loading = true;
      });
    }
    case GET_DETAIL_CAMPAIGN_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.campaign = response?.data;
        draft.loading = false;
      });
    }
    case GET_DETAIL_CAMPAIGN_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }
    case UPDATE_CAMPAIGN_REQUEST: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }
    case UPDATE_CAMPAIGN_SUCCESS: {
      const response = action.payload;
      return produce(state, (draft) => {
        draft.loading = false;
        draft.state = response.data;
      });
    }
    case UPDATE_CAMPAIGN_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    default: {
      return state;
    }
  }
};
export default campaignReducer;
